"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mousePosition = void 0;
const three_1 = require("three");
function mousePosition(event, domElement) {
    const mouse = new three_1.Vector2();
    mouse.x = (event.offsetX / domElement.clientWidth) * 2 - 1;
    mouse.y = -(event.offsetY / domElement.clientHeight) * 2 + 1;
    return mouse;
}
exports.mousePosition = mousePosition;
